import { UIDLeaderboardController } from '../../../ui_leaderboard/UIDLeaderboardController.ts';
export class UIDLeaderboardSceneController {
    hide() {
        this.leaderboardSceneContainerDiv.classList.add('hidden');
    }
    async show() {
        this.leaderboardSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.activateLeaderboard();
        if (this.hasFetched) return;
        await this.leaderboardController.fetchStickyRowData();
        this.hasFetched = true;
        this.leaderboardController.showChangeRegionIncentivePopup();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.leaderboardController = new UIDLeaderboardController();
        this.leaderboardSceneContainerDiv = document.getElementById('scene_discord_leaderboard_container');
        this.hasFetched = false;
    }
}
